class UniversalChargesCache {
  constructor() {
    this.fixedFeeList = [];
    this.lastParams = null;
    this.entryCharges = [];
    this.lastEntryParams = null;
  }
  setCache(charges, params) {
    this.fixedFeeList = charges;
    this.lastParams = params;
  }
  getCache() {
    return {
      fixedFeeList: this.fixedFeeList,
      lastParams: this.lastParams
    };
  }
  setEntryCache(charges, params) {
    this.entryCharges = charges;
    this.lastEntryParams = params;
  }
  getEntryCache() {
    return {
      entryCharges: this.entryCharges,
      lastEntryParams: this.lastEntryParams
    };
  }
  clearCache() {
    this.fixedFeeList = [];
    this.lastParams = null;
    this.entryCharges = [];
    this.lastEntryParams = null;
  }
}
export const chargesCache = new UniversalChargesCache();